import { NAME as APP_NAME, ROUTES as PATCH_ROUTES } from '../constants';

export const NAME = `${APP_NAME}/VIEW`;

export const REDUCER_NAME = 'view';

export const ROUTES = {
  ROOT: `${PATCH_ROUTES.ROOT}/view/:fileName/:fileExtension/:shipperId`,
};
